<template>
    <v-container grid-list-md fluid>
        <v-layout row wrap>
            <v-flex xs12>
               
                <h1>Federal Election {{ year }}</h1>
                <h2 v-if="data.date != null" style="font-size: 1.2rem; display:block">Date: {{ data.date | stringDateFormat }}</h2>

                <v-card  v-if="data.Text != null" class="mt-3 mb-3">
                    <v-card-text class="pt-4 pl-4 pr-4 pb-1">
                        <div v-if="data.Text != null" style="font-size: 1rem" v-html="data.Text"></div>     
                    </v-card-text>
                </v-card>

                   
            </v-flex>
        </v-layout>
        <loader v-if="loading" />        

        <v-layout row wrap>
            <v-flex xs12 md6 v-if="data.Reps">
                <chart :chartData="chartData"/>
            </v-flex>
            <v-flex xs12 md6 v-if="data.Senate">
                <chart :chartData="senateChartData"/>
            </v-flex>
        </v-layout>

        <v-layout row wrap v-if="!loading">
            <v-flex md6 v-if="data.Reps">
                <v-card-title primary-title>
                    <h3 class="headline mb-0">House of Representatives</h3>
                </v-card-title>     
                <v-card>
                    <v-layout row wrap align-center>
                        <v-flex xs12 sm6>
                            <v-card-title>
                                <h3 style="font-weight: 400; font-size: 16px;">
                                    <router-link :to="{ name: 'DivisionalResults' }">
                                        Results by division
                                    </router-link>
                                </h3>
                            </v-card-title>
                        </v-flex>   
                    </v-layout>
                </v-card>    
                <v-divider></v-divider>
                <v-card>
                    <v-layout row wrap align-center>
                        <v-flex xs12 sm6>
                            <v-card-title>
                                <h3 style="font-weight: 400; font-size: 16px;">
                                    <router-link :to="{ name: 'MembersElected' }">
                                        Members elected
                                    </router-link>
                                </h3>
                            </v-card-title>
                        </v-flex>   
                    </v-layout>
                </v-card>    
                <v-divider></v-divider>
                <v-card>
                    <v-layout row wrap align-center>
                        <v-flex xs12 sm6>
                            <v-card-title>
                                <h3 style="font-weight: 400; font-size: 16px;">
                                    <router-link :to="{ name: 'Candidates' }">
                                        House of Representatives candidates
                                    </router-link>
                                </h3>
                            </v-card-title>
                        </v-flex>   
                    </v-layout>
                </v-card>        
            </v-flex>
            <v-flex md6 v-if="data.Senate">
                <v-card-title primary-title>
                    <h3 class="headline mb-0">Senate</h3>
                </v-card-title>    
                <v-card>
                    <v-layout row wrap align-center>
                        <v-flex xs12 sm6 md12 lg6>
                            <v-card-title>
                                <h3 style="font-weight: 400; font-size: 16px;">Overall results by state</h3>
                            </v-card-title>
                        </v-flex>
                        <v-flex xs12 sm6 md12 lg6>
                            <div style="float:right; padding-right:10px;" >
                                <span v-for="state in states" :key="state">
                                    <router-link style="font-weight: 400; font-size: 16px;" :to="{ name: 'SenateResultByState', params: { state: state } }">
                                        {{ state }}
                                    </router-link>&nbsp;                                 
                                </span>
                            </div>
                        </v-flex>
                    </v-layout>
                </v-card>  
                <v-divider></v-divider>
                <v-card>
                    <v-layout row wrap align-center>
                        <v-flex xs12 sm6 md12 lg6>
                            <v-card-title>
                                <h3 style="font-weight: 400; font-size: 16px;">Candidate first preferences by state</h3>
                            </v-card-title>
                        </v-flex>
                        <v-flex xs12 sm6 md12 lg6>
                            <div style="float:right; padding-right:10px;" >
                                <span v-for="state in states" :key="state">
                                    <router-link style="font-weight: 400; font-size: 16px;" :to="{ name: 'SenateResultByCandidate', params: { state: state } }">
                                        {{ state }}
                                    </router-link>&nbsp;                                 
                                </span>
                            </div>
                        </v-flex>
                    </v-layout>
                </v-card>                                             
                <v-divider></v-divider>
                <v-card>
                    <v-layout row wrap align-center>
                        <v-flex xs12 sm6 md12 lg6>
                            <v-card-title>
                                <h3 style="font-weight: 400; font-size: 16px;">Group first preferences by state</h3>
                            </v-card-title>
                        </v-flex>
                        <v-flex xs12 sm6 md12 lg6>
                            <div style="float:right; padding-right:10px;" >
                                <span v-for="state in states" :key="state">
                                    <router-link style="font-weight: 400; font-size: 16px;" :to="{ name: 'SenateResultByGroup', params: { state: state } }">
                                        {{ state }}
                                    </router-link>&nbsp;                                 
                                </span>
                            </div>
                        </v-flex>
                    </v-layout>
                </v-card>
                <v-divider></v-divider>
                <v-card>
                    <v-layout row wrap align-center>
                        <v-flex xs12 sm6 md12 lg6>
                            <v-card-title>
                                <h3 style="font-weight: 400; font-size: 16px;"> Senators elected by state</h3>
                            </v-card-title>
                        </v-flex>
                        <v-flex xs12 sm6 md12 lg6>
                            <div style="float:right; padding-right:10px;" >
                                <span v-for="state in states" :key="state">
                                    <router-link style="font-weight: 400; font-size: 16px;" :to="{ name: 'SenatorsElected', params: { state: state } }">
                                        {{ state }}
                                    </router-link>&nbsp;                                 
                                </span>
                            </div>
                        </v-flex>
                    </v-layout>
                </v-card>                           
                <v-divider></v-divider>
                <v-card>
                    <v-layout row wrap align-center>
                        <v-flex xs12>
                            <v-card-title>
                                <h3 style="font-weight: 400; font-size: 16px;">
                                    <router-link :to="{ name: 'SenateCandidates' }">
                                        Senate candidates
                                    </router-link>          
                                </h3>
                            </v-card-title>
                        </v-flex>
                    </v-layout>
                </v-card>     
            </v-flex>            
        </v-layout>      
        <br />
    </v-container>
    
</template>
<script>
import Loader from '@/components/Loader.vue';
import axios from 'axios';
window.Handbook = window.Handbook || {}
import Chart from '../StatisticalInformation/Chart.vue';
import orderBy from 'lodash.orderby';
import { groupParties } from '../../functions/groupParties';
const apiUri = window.Handbook.ApiUri || "https://localhandbookapi.aph.gov.au/";
axios.defaults.baseURL = apiUri;

export default {
    props: ['year', 'electionId'],
    created() {
        this.loadData();
        this.loadSenateChartData();
        this.loadChartData();
    },
    components: {
        Chart,
        Loader
    },
    data() {
        return {
            loading: true,
            loadingChart: true,
            data: {},
            electedData: [],
            senatorsElectedData: [],
            states: ['NSW', 'VIC', 'QLD', 'WA', 'SA', 'TAS', 'ACT', 'NT']
        }
    },
    methods: {
        loadData() {
            this.loading = true;
            const url = `Elections/Election?electionId=${this.electionId}`;
            axios.get(`api/${url}`)
                .then(response => {
                    this.data = response.data;
                    this.states = response.data.SenateStates.map(s => s.toUpperCase())
                    this.loading = false;
                });
        },
        loadChartData() {
            this.loadingChart = true;
            const url = `Elections/MembersElected?year=${this.year}`;
            axios.get(`api/${url}`)
                .then(response => {
                    this.electedData = response.data;
                    this.loadingChart = false;
                });
        },
        loadSenateChartData() {
            this.loadingChart = true;
            const url = `Elections/SenatorsElected?year=${this.year}`;
            axios.get(`api/${url}`)
                .then(response => {
                    this.senatorsElectedData = response.data;
                    this.loadingChart = false;
                });
        }
    },
    computed: {
        parsedYear() {
            return this.year ? parseInt(this.year) : null
        },
        filteredElectedData() {
            // remove ACT and NT before 1963
            return parseInt(this.year) <= 1963 ?
            this.electedData.filter(e => e.State !== 'ACT' && e.State !== 'NT')
            : this.electedData;
        },
        chartData() {
            const electedData = this.filteredElectedData;
            let parties = [...new Set(electedData.map(d => groupParties(d.Party, this.parsedYear)))];

            let majority = Math.ceil(electedData.length / 2);
            if (electedData.length % 2 === 0) {
                majority++;
            }

            parties = orderBy(parties, [p => electedData.filter(d => groupParties(d.Party, this.parsedYear) === p).length], ['desc']);

            const data = parties
                    // remove territories before and including 1963

                    .map(p => ({ 
                        y:
                            electedData
                            .filter(i => groupParties(i.Party, this.parsedYear) === p ).length,
                        color:
                            electedData
                            .find(i => groupParties(i.Party, this.parsedYear) === p ).PartyColour,
                        }));

            const plotLines = [
                {
                    dashStyle: 'LongDash',
                    // color: '#808080',
                    color: '#939393',
                    value: majority,
                    label: {
                        text: `${majority} to win`,
                        textAlign: 'center',
                        y: -20,
                        rotation: 0
                    }
                }
            ];

            return {
                chart: {
                    type: 'bar',
                    backgroundColor: '#dddddd'
                },
                title: {
                    text: 'House of Representatives results'
                },
                xAxis: {
                    categories: parties,
                    plotLines
                },
                yAxis: {
                    title: {
                        text: ''
                    },
                    plotLines
                },
                legend: {
                    enabled: false
                },
                plotOptions: {
                    bar: {
                        dataLabels: {
                            enabled: true
                        },
                        borderWidth: 0
                    }
                },
                series: [{
                    name: '',
                    data,
                }] 
            }
        },
        senateChartData() {
            let parties = [...new Set(this.senatorsElectedData.map(d => groupParties(d.Party, this.parsedYear)))];
            parties = orderBy(parties, [p => this.senatorsElectedData.filter(d => groupParties(d.Party, this.parsedYear) === p).length], ['desc']);

            const data = parties
                    .map(p => ({ 
                        y: this
                            .senatorsElectedData
                            .filter(i => groupParties(i.Party, this.parsedYear) === p).length,
                        color: this
                            .senatorsElectedData
                            .find(i => groupParties(i.Party, this.parsedYear) === p ).PartyColour,
                        }));

            return {
                chart: {
                    type: 'bar',
                    backgroundColor: '#dddddd'
                },
                title: {
                    text: 'Senate results'
                },
                xAxis: {
                    categories: parties,
                },
                yAxis: {
                    title: {
                        text: ''
                    },
                },
                legend: {
                    enabled: false
                },
                plotOptions: {
                    bar: {
                        dataLabels: {
                            enabled: true
                        },
                        borderWidth: 0,
                        maxPointWidth: 50
                    }
                },
                series: [{
                    name: '',
                    data
                }] 
            }
        }
    }
}
</script>

<style scoped>
    a {
        text-decoration: none;
    }

    .theme--light.v-sheet {
        margin-bottom: 3px;
        border-bottom: 1px solid #c1c1c1;
        border-radius: 0px;
    }
</style>